import React from 'react';

import EcAccountForm from '@components/shared/ec_accounts/EcAccountForm';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';

import { ecAccountService } from '@services/operator/ecAccountService';
import { salesChannelService } from '@services/operator/salesChannelService';
import { shippingTypeService } from '@services/operator/shippingTypeService';

interface ReferenceOption {
  id: string;
  name?: string;
  [key: string]: unknown;
}

interface MerchantShippingTypeRow {
  id: string;
  name?: string;
  code?: string;
  source?: string;
  [key: string]: unknown;
}

// 建立模式：merchant 還沒決定 → 由外層 <MerchantSelect> 引導使用者挑 merchant，
// 之後 OperatorDataContext.currentMerchant 才會就緒，reference data 跟著走。
// 本元件被 New.tsx 與 Edit.tsx 的 create 分支共用 — 兩處渲染必須逐字一致，
// 任何下拉資料來源 / loading gate 的調整都應在這裡改一次即可。
const OperatorEcAccountCreateForm: React.FC = () => {
  const {
    merchantId,
    merchantSalesChannels,
    merchantShippingTypes,
    loading,
  } = useOperatorData() as {
    merchantId: string | null;
    merchantSalesChannels: ReferenceOption[];
    merchantShippingTypes: MerchantShippingTypeRow[];
    loading?: boolean;
  };

  return (
    <EcAccountForm
      ecAccountService={ecAccountService}
      salesChannelService={salesChannelService}
      shippingTypeService={shippingTypeService}
      role="operator"
      mode="create"
      merchantIdForCreate={merchantId}
      salesChannels={merchantSalesChannels ?? []}
      shippingTypes={(merchantShippingTypes ?? []) as ReferenceOption[]}
      merchantDataLoading={!!loading}
    />
  );
};

export default OperatorEcAccountCreateForm;
